const DesignSystemColors = {
  // By name

  // By purpose
  Placeholder: "#868E9988",
};

export default DesignSystemColors;
